// extracted by mini-css-extract-plugin
export default {"sortable-list":"style_sortable-list__+4la6","sortableList":"style_sortable-list__+4la6"};